var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
var Timer = function (_a) {
    var timer = _a.timer;
    var _b = useState('0일 00:00:00'), realTime = _b[0], setRealTime = _b[1];
    var dealTime = useRef(0);
    var interval = useRef();
    var numberLength = function (time) {
        var set = time.toString().length === 2 ? time : "0".concat(time);
        return set;
    };
    var setDealTimer = function () {
        if (timer === '마감')
            return;
        var dayArr = timer.split('일 ');
        var isDay = 1;
        if (dayArr.length === 1) {
            isDay = 0;
        }
        var day = Number(isDay ? dayArr[0] : 0);
        var hour = Number(dayArr[isDay].split(':')[0]);
        var minute = Number(dayArr[isDay].split(':')[1]);
        var second = Number(dayArr[isDay].split(':')[2]);
        var seconds = (day * 86400) + (hour * 3600) + (minute * 60) + second;
        dealTime.current = seconds;
    };
    var setRealTimer = function () {
        if (dealTime.current === 0) {
            window.clearInterval(interval.current);
            return;
        }
        dealTime.current = dealTime.current - 1;
        var calSeconds = dealTime.current;
        var calcDay = Math.floor(calSeconds / 86400);
        var calcHour = Math.floor((calSeconds - (calcDay * 86400)) / 3600);
        var calcMinute = numberLength(Math.floor((calSeconds % 3600) / 60));
        var calcSecond = numberLength(calSeconds % 60);
        var calcTime = "".concat(calcDay, "\uC77C ").concat(calcHour, ":").concat(calcMinute, ":").concat(calcSecond);
        setRealTime(calcTime);
    };
    useEffect(function () {
        setDealTimer();
        interval.current = window.setInterval(setRealTimer, 1000);
        return function () { return window.clearInterval(interval.current); };
    }, []);
    return (React.createElement("span", { className: "time" }, timer === '마감' ? '마감' : React.createElement(React.Fragment, null,
        "\uB0A8\uC740\uC2DC\uAC04 ",
        React.createElement("b", null, realTime))));
};
var Hotdeal = function (_a) {
    var data = _a.data;
    var happyHotDealNumber = 2;
    return (React.createElement(Style, null,
        React.createElement("img", { src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_logo/2_90_50.png"), alt: "\uD589\uBCF5\uD56B\uB51C", className: "logo" }),
        React.createElement(Timer, { timer: data.expires }),
        React.createElement("span", { className: "count" },
            data.f_dp_cnt === 0 ? data.cnt_stock : data.sale_cnt,
            "\uAC1C ",
            data.f_dp_cnt === 0 ? '남음' : '판매')));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n    margin: 0 0 20px;\n    background: #f7f7fa;\n    font-size: 16px;\n    color: #707070;\n\n    .logo {\n        margin: 0 20px 0 0;\n        width: 66px;\n        height: auto\n    }\n    .time {\n        color: #707070;\n\n        b {\n            color: #418ded;\n        }\n    }\n    .count {\n        margin: 0 0 0 auto\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n    margin: 0 0 20px;\n    background: #f7f7fa;\n    font-size: 16px;\n    color: #707070;\n\n    .logo {\n        margin: 0 20px 0 0;\n        width: 66px;\n        height: auto\n    }\n    .time {\n        color: #707070;\n\n        b {\n            color: #418ded;\n        }\n    }\n    .count {\n        margin: 0 0 0 auto\n    }\n"])));
export default Hotdeal;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/detail/hotdeal.tsx
// module id = 206
// module chunks = 0